module.exports = __webpack_public_path__ + "static/media/blog5.351c1d99.jpg";